module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.compIsVisible) ? _c('div', {
    staticClass: "elements_menu bg-lgrey"
  }, [_c('h4', {
    staticClass: "regular h4 c-dark elements_menu_head"
  }, [_c('span', {
    staticClass: "upcase"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.configurator) + "\n\t\t")]), _vm._v("\n\t\t" + _vm._s(_vm.$t("elements")) + "\n\t")]), _vm._v(" "), _c('div', {
    staticClass: "elements_menu_container"
  }, _vm._l((_vm.compElements), function(element, index) {
    return _c('div', {
      staticClass: "menu_element",
      on: {
        "click": function($event) {
          _vm.emitElementClick(element, index)
        }
      }
    }, [_c('div', {
      staticClass: "obj_img_cont"
    }, [_c('img', {
      attrs: {
        "src": element.side_inactive_url
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "medium c-dark h7"
    }, [_vm._v("\n\t\t\t\t" + _vm._s(element.name) + "\n\t\t\t\t"), (element.wood !== null) ? _c('span', {
      staticClass: "h8 regular upcase"
    }, [_vm._v("\n\t\t\t\t  \t" + _vm._s(_vm.$t(element.wood)) + "\n\t\t\t\t")]) : _vm._e()])])
  })), _vm._v(" "), _c('div', {
    staticClass: "elements_menu_actions"
  }, [_c('button', {
    staticClass: "h7 upcase",
    on: {
      "click": _vm.emitClone
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/clone.svg"
    }
  }), _vm._v("\n\t\t\t\t" + _vm._s(_vm.$t("duplicate")) + "\n\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "h7 bg-accent upcase c-light",
    on: {
      "click": _vm.emitConfirm
    }
  }, [_vm._v(_vm._s(_vm.$t("confirm")))])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45e1e9d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/elements/ElementsMenu.vue
// module id = 630
// module chunks = 0